import { CognitoUser } from 'types/others';

export interface LoginProps {
  onStateChange?: (state: string, user?: CognitoUser) => void;
}

export enum LOGIN_STEP {
  INPUT_CREDENTIALS = 'inputCredentials',
  SEND_EMAIL = 'sendEmail',
  CREATE_PASSWORD = 'createPassword',
  ACCESS_READY = 'accessReady',
  TEMPORARY_PASSWORD_SENT = 'temporaryPasswordSent',
}

export type ImageContainerProps = {
  displayInMobile: boolean;
};
